import { render, staticRenderFns } from "./manageCountries.vue?vue&type=template&id=ae8af35c&scoped=true&"
import script from "./manageCountries.vue?vue&type=script&lang=js&"
export * from "./manageCountries.vue?vue&type=script&lang=js&"
import style0 from "./manageCountries.vue?vue&type=style&index=0&id=ae8af35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8af35c",
  null
  
)

export default component.exports